import React from 'react';
import { Container,Card } from './styles';

const AbsoluteData = ({data}) => {
  return (
    <Container>
      <Card>
        <span>Alunos Ativos</span>
        <p><strong>{data?.pessoas_ativas}</strong></p>
      </Card>
      <Card>
        <span>Novos Alunos</span>
        <p><strong>{data?.pessoas}</strong></p>
      </Card>
      <Card>
        <span>Certificados Emitidos</span>
        <p><strong>{data?.certificados_emitidos || 0}</strong></p>
      </Card>
      <Card>
        <span>Novas Empresas</span>
        <p><strong>{data?.empresas || 0}</strong></p>
      </Card>
      <Card>
        <span>Novos Colaboradores</span>
        <p><strong>{data?.new_collabs_incompany || 0}</strong></p>
      </Card>
      <Card>
        <span>Mapeamento de Competências</span>
        <p><strong>{data?.mapeamento_competencias || 0}</strong></p>
      </Card>
      {/* <Card>
        <span>Novos MBAs</span>
        <p><strong>{data?.novos_mbas || 0}</strong></p>
      </Card> */}
      {/* <Card>
        <span>Voitto PRO Ativos</span>
        <p><strong>{data?.pessoas_com_voitto_pro_ativo}</strong></p>
      </Card>
      <Card>
        <span>MBA Ativos</span>
        <p><strong>{data?.pessoas_com_mba_ativos}</strong></p>
      </Card>
      <Card>
        <span>Formações Ativas </span>
        <p><strong>{data?.pessoas_com_formacao_ativos}</strong></p>
      </Card>
      <Card>
        <span>Avulsos Ativos</span>
        <p><strong>{data?.pessoas_com_curso_avulso_ativos}</strong></p>
      </Card> */}
      {/* <Card>
        <span>Total(Qualquer produto)</span>
        <p><strong>{data?.pessoas_com_qualquer_curso_ativo}</strong>/{data?.pessoas_com_qualquer_curso}</p>
      </Card> */}
    </Container>
  );
};

export default AbsoluteData;